<div class="modal fade address-verification-modal" [id]="modalId()" msEscClose (escPressed)="editRequested.emit()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    [attr.aria-labelledby]="titleId()" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" [class.modal-lg]="hasChoice()">
        <div class="modal-content">

            <div class="modal-header border-0 p-4 pb-0">
                <h5 class="modal-title" [id]="titleId()">{{ title() }}</h5>
            </div>

            <div class="modal-body p-4 text-start">
                <div class="alert deliverability-alert d-flex ms-icon-text gap-3" [class]="alertClass()">
                    <fa-duotone-icon [icon]="icon()" secondaryOpacity="0.4" class="fs-4 flex-shrink-0" />
                    <div class="flex-grow-1">
                        <h6 class="alert-heading mb-1">{{ deliverabilityLabel() }}</h6>
                        @if (deliverabilityDescription()) {
                            <p class="mb-0">{{ deliverabilityDescription() }}</p>
                        }
                    </div>
                </div>

                <p class="mb-0" [id]="promptId()">{{ promptText() }}</p>

                @if (hasChoice()) {
                    <div class="row g-3 mt-3" role="radiogroup" [attr.aria-labelledby]="promptId()">
                        <div class="col-12 col-md-6">
                            <label class="address-choice h-100"
                                [class.address-choice-selected]="selectedChoice() === AddressVerificationChoice.Original">
                                <input type="radio" class="form-check-input flex-shrink-0" [name]="radioGroupName()"
                                    [checked]="selectedChoice() === AddressVerificationChoice.Original"
                                    (change)="select(AddressVerificationChoice.Original)" />
                                <span>
                                    <span class="address-choice-label d-block">{{ Messages.LABEL_ORIGINAL() }}</span>
                                    @for (line of originalLines(); track $index) {
                                        <span class="d-block">{{ line }}</span>
                                    }
                                </span>
                            </label>
                        </div>
                        <div class="col-12 col-md-6">
                            <label class="address-choice h-100"
                                [class.address-choice-selected]="selectedChoice() === AddressVerificationChoice.Standardized">
                                <input type="radio" class="form-check-input flex-shrink-0" [name]="radioGroupName()"
                                    [checked]="selectedChoice() === AddressVerificationChoice.Standardized"
                                    (change)="select(AddressVerificationChoice.Standardized)" />
                                <span>
                                    <span class="address-choice-label d-block">{{ Messages.LABEL_STANDARDIZED() }}</span>
                                    @for (line of standardizedLines(); track $index) {
                                        <span class="d-block">{{ line }}</span>
                                    }
                                </span>
                            </label>
                        </div>
                    </div>
                } @else {
                    <div class="address-choice address-choice-static mt-3">
                        <span>
                            <span class="address-choice-label d-block">{{ Messages.LABEL_ORIGINAL() }}</span>
                            @for (line of singleSideLines(); track $index) {
                                <span class="d-block">{{ line }}</span>
                            }
                        </span>
                    </div>
                }

                @if (hasChoice()) {
                    <div class="mt-3" role="status">
                        <div class="alert alert-warning d-flex ms-icon-text gap-3 mb-0"
                            [class.invisible]="!showUnverifiedWarning()"
                            [attr.aria-hidden]="showUnverifiedWarning() ? null : 'true'">
                            <fa-duotone-icon icon="triangle-exclamation" secondaryOpacity="0.4" />
                            <span>{{ Messages.UNVERIFIED_SELECTION_WARNING() }}</span>
                        </div>
                    </div>
                }
            </div>

            <div class="modal-footer border-0 d-flex flex-wrap justify-content-center gap-2 pb-4">
                <button type="button" class="btn"
                    [class]="editIsPrimaryAction() ? 'btn-primary' : 'btn-ms-secondary'"
                    (click)="editRequested.emit()">
                    {{ Messages.BUTTON_EDIT() }}
                </button>
                <button type="button" class="btn"
                    [class]="editIsPrimaryAction() ? 'btn-ms-secondary' : 'btn-primary'"
                    (click)="onConfirm()">
                    {{ Messages.BUTTON_CONFIRM() }}
                </button>
            </div>

        </div>
    </div>
</div>
